import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import commonMethod from '../../lib/commonMethod';
import cookie from 'react-cookies';
import qs from 'query-string';
import MotionDoorHistory from '../../components/History/MotionDoorHistory';
import TempHumidityHistory from '../../components/History/TempHumidityHistory';
import Refresh from '../../components/Refresh.js';
import RefTempHumidityHistory from '../../components/History/RefTempHumidityHistory';

import '../../assets/css/history.scss';

function History(props) {
  const dispatch = useDispatch();
  const {
    loading,
    familyList,
    familyId,
    roomList,
    roomId,
    deviceList,
    deviceId
  } = useSelector(state => state.location);
  const { isRefresh } = useSelector(state => state.hejhome);
  const accessToken = useMemo(() => cookie.load('accessToken'), []);
  const [qsState, setQsState] = useState(undefined);

  useEffect(() => {
    if (window.location.search) {
      const queryString = qs.parse(window.location.search);
      setQsState(queryString);
    }
  }, [window.location.search]);

  useEffect(() => {
    if (qsState) {
      dispatch({
        type: 'setFamilyId',
        familyId: Number(qsState.familyId) || undefined
      });
    }
  }, [qsState, dispatch]);

  useEffect(() => {
    if (qsState) {
      dispatch({ type: 'setRoomId', roomId: qsState.roomId });
    }
  }, [qsState, dispatch]);

  useEffect(() => {
    if (qsState) {
      dispatch({ type: 'setDeviceId', deviceId: qsState.deviceId });
    }
  }, [qsState, dispatch]);

  const [deviceType, deviceName] = useMemo(() => {
    for (const info of deviceList || []) {
      if (info.id === deviceId) {
        return [info.deviceType, info.name];
      }
    }
    return [undefined, undefined];
  }, [deviceList, deviceId]);

  useEffect(() => {
    if (isRefresh && !deviceId) {
      setTimeout(() => {
        dispatch({ type: 'setIsRefresh', isRefresh: false });
      }, 1000);
    }
  }, [dispatch, isRefresh, deviceId]);

  useEffect(() => {
    dispatch({ type: 'setLocationLoading', loading: 'families' });
    commonMethod.requestGetWithToken(
      'dashboard/family',
      accessToken,
      this,
      res => {
        dispatch({ type: 'setFamilyList', families: res.result });
        dispatch({ type: 'setLocationLoading', loading: false });
      },
      err => {
        console.log(err);
      }
    );
  }, [accessToken, dispatch]);

  useEffect(() => {
    if (familyId) {
      dispatch({ type: 'setLocationLoading', loading: 'rooms' });
      commonMethod.requestGetWithToken(
        `dashboard/rooms/${familyId}`,
        accessToken,
        this,
        res => {
          dispatch({ type: 'setRoomList', roomList: res.result.rooms });
          dispatch({ type: 'setLocationLoading', loading: false });
        },
        (req, status, err) => {
          console.error(err);
        }
      );
    }
  }, [accessToken, familyId, dispatch, qsState]);

  useEffect(() => {
    if (roomId) {
      dispatch({ type: 'setLocationLoading', loading: 'devices' });
      commonMethod.requestGetWithToken(
        `dashboard/${familyId}/room/${
          roomId === 'ALL' ? 'all' : roomId
        }/sensors?scope=shop`,
        accessToken,
        this,
        res => {
          dispatch({ type: 'setDeviceList', deviceList: res });
          dispatch({ type: 'setLocationLoading', loading: false });
        },
        err => {
          console.error(err);
        }
      );
    }
  }, [accessToken, familyId, roomId, dispatch]);

  const onSelectFamily = useCallback(
    e => {
      dispatch({
        type: 'setFamilyId',
        familyId: Number(e.target.value) || undefined
      });
    },
    [dispatch]
  );

  const onSelectRoom = useCallback(
    e => {
      const roomId = e.target.value === 'ALL' ? 'ALL' : Number(e.target.value);
      dispatch({ type: 'setRoomId', roomId: roomId || undefined });
    },
    [dispatch]
  );

  const onSelectDevice = useCallback(
    e => {
      const deviceId = e.target.value === '0' ? undefined : e.target.value;
      dispatch({ type: 'setDeviceId', deviceId });
    },
    [dispatch]
  );

  return (
    <>
      {isRefresh && <Refresh />}
      <div id="history">
        <div
          className="history-item-select"
          style={{ background: '#292B2F', height: '50px' }}
        >
          <select onChange={onSelectFamily} value={familyId}>
            <option value="0">
              {loading === 'families' ? '장소 로딩중..' : '장소 선택'}
            </option>
            {familyList &&
              familyList.map((item, index) => {
                return (
                  <option value={item.familyId} key={index}>
                    {item.name}
                  </option>
                );
              })}
          </select>
          <span>/</span>
          <select value={roomId} disabled={!familyId} onChange={onSelectRoom}>
            <option value="0">
              {loading === 'rooms' ? '방 로딩중..' : '방 선택'}
            </option>
            {roomList && <option value="ALL">ALL</option>}
            {roomList &&
              roomList.map((item, index) => {
                return (
                  <option value={item.room_id} key={index}>
                    {item.name}
                  </option>
                );
              })}
          </select>
          <span>/</span>
          <select
            value={deviceId || '0'}
            disabled={(deviceList || []).length === 0}
            onChange={onSelectDevice}
          >
            {loading === 'devices' && <option>디바이스 로딩중..</option>}
            {loading !== 'devices' && (
              <option value="0">
                {deviceList && deviceList.length === 0
                  ? '디바이스 없음'
                  : '디바이스 선택'}
              </option>
            )}
            {deviceList &&
              deviceList.length > 0 &&
              deviceList.map((item, index) => {
                return (
                  <option value={item.id} key={index}>
                    {item.name}
                  </option>
                );
              })}
          </select>
        </div>
        <div className="history-item-content">
          <div>
            {!deviceId && (
              <h2>히스토리를 확인 할 장소, 방, 디바이스를 선택해주세요.</h2>
            )}
            {['SensorTh', 'SensorTh2'].includes(deviceType) && (
              <TempHumidityHistory
                deviceId={deviceId}
                deviceName={deviceName}
                deviceType={deviceType}
                history={props.history}
              />
            )}
            {['SensorDo', 'SensorMo'].includes(deviceType) && (
              <MotionDoorHistory
                deviceId={deviceId}
                deviceName={deviceName}
                deviceType={deviceType}
                history={props.history}
              />
            )}
            {['SensorRefTh', 'SensorRefTh2'].includes(deviceType) && (
              <RefTempHumidityHistory
                deviceId={deviceId}
                deviceName={deviceName}
                deviceType={deviceType}
                history={props.history}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default History;
